/**
 * 历史跟进记录
 * @author tylerzzheng
 */
import { useEffect, useMemo } from 'react'
import { ExtendItem, HistoryFollowListFilter, sortTypeEnum, HistorySdrFollowListFilter, HistorySdrFollowListItem } from '@types'
import { parseExtend, parseFollowExtend } from '@library'
import { getSDRFollowRecordList } from '@services/customer'
import { useTableService } from '@hooks/useTableService'
import { clone } from 'lodash'

type HistorySdrFollowData = HistorySdrFollowListItem & {
  extendObj?: {[key: string]: any},
  extendArr?: ExtendItem[],
  intention?: string
  followType?: string
}
export function useSdrFollowList (customerId: number) {
  /**
   * 历史跟进记录
   */
  const initRecordFilter = useMemo<HistoryFollowListFilter | HistorySdrFollowListFilter>(() => ({
    page: 1,
    pageSize: 5,
    sort: 'createTime',
    sortType: sortTypeEnum.DESC,
    customerId,
  }), [customerId])

  const {
    loading,
    list,
    pagination,
    filter,
    setFilter,
    reload,
    rowKey,
  } = useTableService(
    getSDRFollowRecordList,
    initRecordFilter,
    '获取历史跟进记录失败',
  )

  useEffect(() => {
    setFilter({ customerId })
  }, [customerId])

  const historySdrFollowList: HistorySdrFollowData[] = useMemo(() => (list as HistorySdrFollowListItem[]).map(item => {
    const historyFollowData: any = clone(item)
    const extendObj = parseFollowExtend(item?.extend)
    historyFollowData.extendObj = extendObj
    historyFollowData.extendArr = parseExtend(item?.extend)
    historyFollowData.intention = `${item.intentionName}-${item.subIntentionName}`
    historyFollowData.followType = item.followType.join?.(',')
    historyFollowData.interestProduct = `${item.interestSmallProductName}-${item.interestSubProductName}`
    historyFollowData.touchIssue = `${item?.touchIssueCh}-${item?.touchIssueDetail}`
    return historyFollowData
  }), [list])

  return [
    loading,
    historySdrFollowList,
    pagination,
    filter,
    setFilter,
    reload,
    rowKey,
  ] as const
}
